import { Component, OnInit,Output,Input,EventEmitter } from '@angular/core';

@Component({
  selector: 'app-rating-value',
  templateUrl: './rating-value.component.html',
  styleUrls: ['./rating-value.component.sass']
})
export class RatingValueComponent implements OnInit {
  @Output() private ratingValue = new EventEmitter();
  @Input('rate') reviewRate: number;
  constructor() { }
  ngOnInit(): void {

  }

  rating(e) {
    this.reviewRate = e;
    this.ratingValue.emit(e);
  }

}
